import { render } from "./SimpleInput.vue?vue&type=template&id=5448eee2"
import script from "./SimpleInput.vue?vue&type=script&lang=js"
export * from "./SimpleInput.vue?vue&type=script&lang=js"

import "./SimpleInput.vue?vue&type=style&index=0&id=5448eee2&lang=less"
script.render = render

export default script